module.exports = __webpack_public_path__ + "img/sawaf-logo-white.71dbf161.png";